// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cQ-z","isFullWidth":"dQ-z","landingPageVideo":"eQ-z","play":"fQ-z","iframeVideo":"gQ-z","playHidden":"hQ-z","fullwidth":"iQ-z"};